import apiClient from '../apiClient';

/**
 * Get current tenant information
 */
export const getCurrentTenant = async () => {
    try {
        const response = await apiClient.get('/tenants/current');

        // Backend may return paginated response
        // Extract tenant from content array if present, otherwise use response.data directly
        if (response.data.content && Array.isArray(response.data.content)) {
            return response.data.content[0] || null;
        }

        return response.data;
    } catch (error) {
        console.error('Error fetching current tenant:', error);
        throw error;
    }
};

/**
 * Update tenant profile
 */
export const updateTenantProfile = async (profileData) => {
    try {
        const response = await apiClient.put('/tenants/current/profile', profileData);
        return response.data;
    } catch (error) {
        console.error('Error updating tenant profile:', error);
        throw error;
    }
};

/**
 * Update subscription
 */
export const updateSubscription = async (subscriptionData) => {
    try {
        const response = await apiClient.post('/tenant/subscription/update', subscriptionData);
        return response.data;
    } catch (error) {
        console.error('Error updating subscription:', error);
        throw error;
    }
};

/**
 * Cancel subscription
 */
export const cancelSubscription = async () => {
    try {
        const response = await apiClient.post('/tenant/subscription/cancel', null);
        return response.data;
    } catch (error) {
        console.error('Error canceling subscription:', error);
        throw error;
    }
};

/**
 * Get current tenant context/metadata
 */
export const getTenantContext = async () => {
    try {
        const response = await apiClient.get('/tenants/context');
        return response.data;
    } catch (error) {
        console.error('Error fetching tenant context:', error);
        throw error;
    }
};

/**
 * Handle API errors and return user-friendly messages
 */
export const handleApiError = (error) => {
    if (error.response) {
        const status = error.response.status;
        const data = error.response.data;

        switch (status) {
            case 400:
                return data.message || 'Invalid data. Please check your input.';
            case 401:
                return 'Session expired. Please login again.';
            case 403:
                return 'You do not have permission to perform this action.';
            case 404:
                return 'Tenant not found.';
            case 500:
                return 'Server error. Please try again later.';
            default:
                return data.message || 'An error occurred. Please try again.';
        }
    } else if (error.request) {
        return 'Network error. Please check your connection.';
    } else {
        return error.message || 'An unexpected error occurred.';
    }
};
